// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../newstyle"

Rails.start()
Turbolinks.start()
// Quando a página nova tem layout ou pacotes diferentes, o Turbolinks não a renderiza: recarrega o navegador, que
// devolveria a rolagem da anterior. Sem renderização, a entrada da página nova fica sem restauração e ela abre no topo.
let visitRendered = true
document.addEventListener('turbolinks:request-end', () => { visitRendered = false })
document.addEventListener('turbolinks:render', () => { visitRendered = true })
document.addEventListener('turbolinks:load', () => {
  if (!visitRendered) {
    history.scrollRestoration = 'manual'
    return
  }
  const navigation = performance.getEntriesByType('navigation')[0]
  const reloadedByVisit = navigation && navigation.type === 'reload' && history.scrollRestoration === 'manual'
  if (!reloadedByVisit) history.scrollRestoration = 'auto'
})
ActiveStorage.start()
